import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

/** No mailbox yet (design outreach-v2 q4): one icon, one line, one button. */
const MailboxEmptyComponent: React.FC<{ onConnect: () => void }> = ({ onConnect }) => {
  const intl = useIntl();
  return (
    <div className={styles.empty} data-testid="mailbox-empty">
      <span className={styles.emptyIcon} aria-hidden="true">
        <FontAwesomeIcon icon={faEnvelope} />
      </span>
      <b>{intl.formatMessage(messages.emptyTitle)}</b>
      <p>{intl.formatMessage(messages.emptyBody)}</p>
      <SMLButton color="primary" omitCap leftIcon={faPlus} onClick={onConnect} testID="mailbox-connect">
        {intl.formatMessage(messages.connect)}
      </SMLButton>
    </div>
  );
};

export const MailboxEmpty = TypedMemo(MailboxEmptyComponent);
